import { useTranslation } from 'react-i18next';

import { useStylistAiContext } from '../../contexts/StylistAiContext';

import { ProductList } from './ProductList';

export function RecommendedProducts() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.StylistAi.components.RecommendedProducts',
  });
  const { queryText, hasProducts } = useStylistAiContext();

  if (!queryText) {
    return null;
  }

  return (
    <div>
      {hasProducts && (
        <h2 className="mb-4 text-lg font-semibold">{t('title')}</h2>
      )}

      <ProductList />
    </div>
  );
}
